import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { IAppDB } from '@/shared/lib/db';
import type { CartItem } from '@/shared/lib/db/schemas/cart.schema';

export type UseCaseInput = void;
export type UseCaseOutput = CartItem[];

export class ListItemsUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private db: IAppDB;

  constructor(db: IAppDB) {
    this.db = db;
  }

  async execute(): Promise<UseCaseOutput> {
    return this.db.items.toArray();
  }
}
